import { render, staticRenderFns } from "./TravelProductList.vue?vue&type=template&id=363bad33&"
import script from "./TravelProductList.vue?vue&type=script&lang=js&"
export * from "./TravelProductList.vue?vue&type=script&lang=js&"
import style0 from "./TravelProductList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelProductList.vue"
export default component.exports